// extracted by mini-css-extract-plugin
export default {"layout":"Offer_layout__pANja"};